// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__IV_9g","content":"Header_content__1XPsD","touch":"Header_touch__3y5J2"};